function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Play_Button",
  "data-name": "Play Button",
  transform: "translate(-525 -4441)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Button",
  cx: 75,
  cy: 75,
  r: 75,
  transform: "translate(525 4441)",
  fill: "#3658a4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M626.264,4515.455l-40.616-18.813A4.2,4.2,0,0,0,583.7,4496c-1.192,0-2.708.752-2.708,2.151v38.7c0,1.4,1.516,2.149,2.708,2.149a4.193,4.193,0,0,0,1.949-.645l40.616-18.813c.866-.432,1.733-.861,1.733-2.043S627.131,4515.886,626.264,4515.455Z",
  fill: "#fff"
}));

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.3fd46c14.svg";
export { ForwardRef as ReactComponent };